export default __webpack_public_path__ + "static/media/deposit.7a98f945.png";